<template>
  <div>
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeNum"
      @changePage="changePage"
      @search="search"
    ></ots-table-group-new>

    <ots-custom-dialog :dialog.sync="useCountDialog" title="授权码使用详情查看" width="50%">
      <template v-slot:content>
        <ots-table-group-new
          :tableHeader="authTableHeader"
          :tableData="authTableData"
        ></ots-table-group-new>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import { getSelectPlanFn } from "@/http/modules/examSet/examBatch";
import { getCurrentSelectPlace } from "@/http/modules/examSet/planClass";
import { getSelectClassAPI, getSelectAuthCodeTypeAPI, queryListAPI, exportAuthCodeAPI } from "@/http/modules/computedRoomExam";

export default {
  data() {
    return {
      mainTopBtnList: [
        {
          title: "导出授权码",
          fn: this.exportAuthCode,
        },
        {
          title: "导出查询结果",
          fn: this.exportInfo,
        },
      ],
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '考点名称',
          type: 'select',
          requestKey: 'placeId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '教室名称',
          type: 'select',
          requestKey: 'classId',
          label: 'name',
          value: 'id',
          data: [],
        },        
        {
          title: '机器类型',
          type: 'select',
          requestKey: 'machineTypeId',
          label: 'name',
          value: 'id',
          data: [
            {id: '', name: '全部'},
            {id: 1, name: '管理机'},
            {id: 2, name: '考试机'}
          ],
        },        
        {
          title: '授权码类型',
          type: 'select',
          requestKey: 'authCodeTypeId',
          label: 'authcodeType',
          value: 'id',
          data: [],
        },
        {
          title: "授权码是否使用",
          type: "select",
          requestKey: "authCodeIsUsed",
          label: "name",
          value: 'id',
          data: [
            {id: "", name: '全部'},
            {id: 1, name: '是'},
            {id: 0, name: '否'}
          ],
        }
      ],
      pagination: {
        total: 0,
      },
      tableData: [],
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "考点名称",
          prop: "placeName",
        },
        {
          title: "教室名称",
          prop: "className",
        },
        {
          title: "机器类型",
          prop: "machineTypeName",
        },
        {
          title: "授权码类型",
          prop: "authCodeTypeName",
        },
        {
          title: "授权码",
          prop: "authCode",
        },
        {
          title: "授权码是否使用",
          prop: "authCodeIsUsed"
        },
        {
          title: "授权码使用次数",
          prop: "authCodeUsedCount",
          type: "button",
          disableFn: (scope) => {
            return scope.row.authCodeUsedCount == 0
          },
          click: this.authCodeUsedCount,
        },
      ],
      requestForm: {
        planId: '',
        placeId: '',
        classId: '',
        machineTypeId: '',
        authCodeTypeId: '',
        authCodeIsUsed: "",
        size: 10,
        page: 1,
      },
      useCountDialog: false,
      authTableData: [],
      authTableHeader: [
        {
          title: "机器码",
          prop: "machineId"
        },
        {
          title: "使用时间",
          prop: "useTime"
        }
      ]
    }
  },
  watch: {
    'requestForm.planId': function(value) {
      this.getPlace(value);
      this.getTableData();
    },
    'requestForm.placeId': function(value) {
      this.getClass();
    },
    'requestForm.machineTypeId': function(value) {
      this.getCodeType(value);
    }
  },
  created() {
    this.getPlan();
    this.getCodeType();
  },

  methods: {
    // 授权码使用弹窗
    authCodeUsedCount(row) {
      this.authTableData = row.authCodeUsedDetails;
      this.useCountDialog = true;
    },

    search() {
      this.requestForm.page = 1;
      this.getTableData();
    },

    // 获取批次
    async getPlan() {
      const { data: planData } = await getSelectPlanFn();
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },

    // 获取授权码类型
    async getCodeType(value) {
      const { data: codeTypeData } = await getSelectAuthCodeTypeAPI({machineTypeId: value});
      this.selectList[4].data = [{id: '', computerType: '', authcodeType: "全部"}, ...codeTypeData];
      this.requestForm.authCodeTypeId = '';
    },

    // 获取考点
    async getPlace(value) {
      const { data: placeData } = await getCurrentSelectPlace({planId: value});
      if (!placeData) {
        this.selectList[1].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[1].data = [{id: '', name: '全部'}, ...placeData];
      this.requestForm.placeId = "";
    },

    // 获取教室
    async getClass() {
      let params = {
        planId: this.requestForm.planId,
        placeId: this.requestForm.placeId
      }
      const { data: classData } = await getSelectClassAPI(params);
      if (classData.length === 0) {
        this.selectList[2].data = [];
        this.requestForm.classId = '';
        return;
      }
 
      this.selectList[2].data = [{id: '', name: '全部'}, ...classData];
      this.requestForm.classId = '';
    },

    // 获取表格数据
    async getTableData() {
      let params = { ...this.requestForm }
      const { data: tableData } = await queryListAPI(params);
      this.pagination.total = tableData.total;
      this.tableData = tableData.records;
    },

    // 导出查询结果
    async exportInfo() {
      let params = { ...this.requestForm };
      let result = await exportAuthCodeAPI(params)
      if (result.code === 1) {
        window.open(result.data);
      }
    },

    // 导出授权码
    async exportAuthCode() {
      let params = { ...this.requestForm };
      params.exportType = 1;
      let result = await exportAuthCodeAPI(params)
      if (result.code === 1) {
        window.open(result.data);
      }
    },

    changeNum(num) {
      this.requestForm.size = num
      this.getTableData()
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }

}
</script>
